import { render, staticRenderFns } from "./AddUserSite.vue?vue&type=template&id=23dc8a6f"
import script from "./AddUserSite.vue?vue&type=script&lang=js"
export * from "./AddUserSite.vue?vue&type=script&lang=js"
import style0 from "./AddUserSite.vue?vue&type=style&index=0&id=23dc8a6f&prod&lang=scss"
import style1 from "@/assets/scss/pages/user-site/add-user-site.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports